<template>
  <div class="search-host">
    <div class="search-component">
      <div class="search-container">
        <v-icon v-if="searchIcon">mdi-magnify</v-icon>
        <input type="text" ref="input" :placeholder="localPlaceholder" :style="localStyle" class="selectorContent"
          v-model="localSearch" />
      </div>
      <div v-if="filters && filters.length > 0" class="search-category-dropdown-container">
        <v-select v-model="searchCategory" :items="filters" item-text="label" item-value="value" dense outlined
          placeholder="Select" clearable class="search-select" />
      </div>

    </div>
    <div v-if="updateDateRangeCallback" class="date-controls-container">
      <v-menu v-model="menu" :close-on-content-click="false" offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
          <v-icon>mdi-calendar-blank-outline</v-icon>
          <v-text-field v-model="displayRange" label="Select date range" v-bind="attrs" solo flat v-on="on" />
        </template>

        <v-date-picker v-model="range" range :show-current="false">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false; range = []">
            Cancel
          </v-btn>
          <v-btn text color="primary" @click="() => {
            menu = false
            handleRangeUpdate(range)
            refreshData()
          }">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    </div>
    <div class="search-bar-button-bar">
      <div v-if="showSupportButtons" class="search-bar-button-bar-item">
        <button class="search-bar-button" @click="() => showFiltersModal()">
          <v-icon>mdi-filter-outline</v-icon>
          <p>Filters</p>
        </button>
      </div>
      <div v-if="clearFiltersCallback" class="search-bar-button-bar-item">
        <button class="search-bar-button" @click="() => clearFilters()">
          <v-icon>mdi-filter-remove-outline</v-icon>
          <p>Clear Filters</p>
        </button>
        <button v-if="exportDataCallback" class="search-bar-button" @click="() => exportData()">
          <v-icon>mdi-download</v-icon>
          <p>Export</p>
        </button>
        <button class="search-bar-button" @click="() => refreshData()">
          <v-icon style="margin-right: 0px;">mdi-refresh</v-icon>
        </button>
      </div>
    </div>
  </div>


</template>


<script>

// import * as Constants from '../../../js/constants';
import SelectFiltersModal from '../../modals/SelectFiltersModal.vue';
export default {
  name: "SearchBar",
  props: ["search", "searchCallback", "placeholder", "inputStyle", "searchIcon",
    "exportDataCallback", "filters", "updateDateRangeCallback", "showSupportButtons",
    "clearFiltersCallback", "searchCategoryUpdated", "updateFiltersCallback",
    "filterConfiguration", "currentFilters", "hideReset", "autoFocus"],
  watch: {
    localSearch(newVal, oldVal) {
      let newSearchTime = new Date().getTime();
      if (this.$props.searchCategoryUpdated != null && this.$props.searchCategoryUpdated != undefined) {
        this.$props.searchCategoryUpdated(this.searchCategory)
      }
      clearTimeout(this.timeout);
      if (newVal.trim() !== oldVal.trim() && newVal.trim().length > 2) {
        this.timeout = setTimeout(() => {
          console.log("Last Search", this.searchLastUpdated);
          this.searchLastUpdated = newSearchTime;
          this.$props.searchCallback(newVal.trim()); // Call the parent's callback with the new value
        }, 150);
      } else if (newVal.length == 0) {
        this.timeout = setTimeout(() => {
          this.$props.searchCallback(newVal.trim());
        }, 150);
      }
    },
    search(newVal) {
      // Sync the prop value to the local data when the parent changes the prop
      this.localSearch = newVal;
    },
    range(newVal) {
      this.handleRangeUpdate(newVal)
    },
    searchCategory(newVal) {
      if (newVal == "" || newVal == null) {
        this.localSearch = ""
      }
      this.$props.searchCategoryUpdated(newVal)
    }
  },
  data() {
    return {
      localSearch: this.search, // Initialize the localSearch with the prop value
      searchLastUpdated: new Date().getTime(),
      localPlaceholder: this.$props.placeholder ?? "Search",
      localStyle: this.$props.inputStyle ?? "",
      localSearchIcon: this.$props.searchIcon ?? false,
      searchCategory: null,
      searchCategories: [
        "Any",
        "Name",
        "Address",
      ],
      range: [],
      menu: false,
      timeout: null
    }
  },
  mounted() {
    if(this.$props.autoFocus) {
      this.$refs.input.focus()
    }
  },
  computed: {
    displayRange() {
      if (!this.range || this.range.length < 2) return ''
      let returnRange = [...this.range].sort(
        (a, b) => new Date(a) - new Date(b)
      )
      return `${returnRange[0]} → ${returnRange[1]}`
    }
  },
  methods: {
    clearFilters() {
      this.searchCategory = ""
      this.range = []
      this.localSearch = ""
      this.$props.clearFiltersCallback()
    },
    refreshData() {
      this.$props.searchCallback(this.search)
    },
    exportData() {
      if (!this.$props.exportDataCallback) return
      this.$props.exportDataCallback()
    },
    showFiltersModal() {
      this.$modal.show(SelectFiltersModal, {
        filterConfiguration: this.$props.filterConfiguration,
        currentFilters: this.$props.currentFilters,
        hideReset: this.$props.hideReset,
        updateFiltersCallback: this.$props.updateFiltersCallback
      }, {
        transition: "fade",
        top: "0",
        width: "370",
        height: "auto",
        draggable: "true",
        adaptive: false,
        styles: "border-radius: 8px;"
      }
      )
    },
    handleRangeUpdate(newVal) {
      if (newVal.length > 1) {
        let returnRange = [...newVal].sort(
          (a, b) => new Date(a) - new Date(b)
        )
        this.$props.updateDateRangeCallback(returnRange)
      }
    }
  }


}

</script>


<style>
/* TODO: Mobile Sizing */
.search-host {
  text-align: left;
  flex-direction: row;
  display: flex;
  align-items: center;
  width: 100%;
}

.search-component {
  text-align: left;
  flex-direction: row;
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid rgba(161, 161, 170, 1);
  height: 40px;
  width: 100%;
  /* max-width: 650px; */
}

.selectorContent {
  width: 100%;
  font-size: 14px;
  font-weight: 550;
  border: 0;
  outline: 0;

}

.search-container {
  text-align: left;
  flex-direction: row;
  display: flex;
  align-items: center;
  flex: 4
}


.searchIcon {
  margin: 0px 4px;
}

.search-category-dropdown-container {
  font-size: 8px;
  height: 40px;
  max-height: 40px;
}


.date-controls-container {
  min-width: 250px;
  font-size: 8px;
  height: 40px;
  max-height: 40px;
  margin-left: 8px;
  margin-right: 8px;
  border: 1px solid rgba(161, 161, 170, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 8px 0px 8px;
}

.date-controls-container .v-text-field {
  padding: 0;
  margin: 0;
  height: 100%;
}

.date-controls-container .v-input__control {
  padding: 0;
  margin: 0;
  height: 100%;
  min-height: 40px !important;
  text-align: center;
}


.v-text-field__slot input {
  text-align: left;
  line-height: normal;
  padding: 0;
}

.v-input__prepend-outer {
  margin-right: 8px;
}

.search-select {
  max-width: 160px;
}

.v-select .v-select__selection {
  font-size: 12px;
}

.v-input__slot {
  padding: 0 !important;
  background: none !important;
}

.v-select__slot {
  padding-left: 4px;
}

.v-input__slot fieldset {
  border: 0;
  border-left: 1px solid gray;
  border-radius: 0;
}

.v-picker__title {
  color: black;
}

.v-date-picker-table .v-btn.v-btn--active {
  color: inherit !important;
}

::-ms-input-placeholder {
  /* Edge 12 -18 */
  color: black;
  font-weight: 550;
}

.search-bar-button-bar {
  display: flex;
  flex: 2;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 8px;
}

.search-bar-button-bar-item {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.search-bar-button {
  background: none;
  border: 1px solid rgba(161, 161, 170, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 16px;
  height: 40px;
}

.search-bar-button:hover {
  transition: .3s;
  background-color: rgba(161, 161, 170, 1);
  color: white;
}

.search-bar-button:hover .v-icon {
  transition: .3s;
  color: white;
}

.search-bar-button p {}

.v-icon {
  margin-right: 8px;
}
</style>